import { getCurrentStep } from '../../helpers';

function sanitizeInputValues(value) {
	if (!value || typeof value !== 'string') {
		return false;
	}
	return value?.replace(/\W+/g, ' ').trim();
}

export function dedupeFirstAndLastName($activeStep = null, formData) {
	const currentStep = $activeStep ? $activeStep : getCurrentStep();
	const $firstName = currentStep?.querySelector('input[name="firstName"]');
	const $lastName = currentStep?.querySelector('input[name="lastName"]');

	if ($firstName && $lastName) {
		const firstName = sanitizeInputValues($firstName?.value);
		const lastName = sanitizeInputValues($lastName?.value);

		if (firstName && lastName && firstName === lastName) {
			// Replacing all the spaces + multiple space + special chars with single space
			const filteredInfo = firstName?.split(' ');
			// Assigning last element value to last name
			$lastName.value = filteredInfo.pop();
			// Rest of the elements will be considered as first name
			$firstName.value = filteredInfo.length > 1 ? filteredInfo.join(' ') : filteredInfo.join('');
			// Update the formData object as well
			formData.firstName = $firstName.value;
			formData.lastName = $lastName.value;

			window.Modalytics.heap('track', ['Dedupe Input | First and Last Name']);
		}
	}

	return formData;
}
